import { addStyles } from 'ethcss'
import { IStyles } from '../../../theme'

const deviceSettingsStyles: IStyles = {
    content: {
        width: '60%',
    },
    switchWrapper: {
        display: 'flex',
    },
    switchWrapperSpaced: {
        marginTop: 16,
    },
    switchCaption: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 14,

        span: {
            marginRight: 6,
        },
    },
    field: {
        width: '60%',
        marginTop: 21,
    },
}

addStyles(deviceSettingsStyles)
export default deviceSettingsStyles
